import { useClassifierServiceGetClassifierListEndpoint } from 'src/api/queries'
import { ClassifierCategory, ClassifierType } from 'src/api/requests'

export const useClassifierId = (
  type: ClassifierType,
  category: ClassifierCategory
) => {
  const { data: classifiers } = useClassifierServiceGetClassifierListEndpoint(
    {
      category,
      pageSize: 100
    },
    [category],
    {
      enabled: !!category
    }
  )

  const id = classifiers?.data?.find((item) => item.type === type)?.id

  return id
}
